<div class="source-badges">
	<span style="color: hsla(var(--hsl-source-olx));">olx.pl</span>
	<span style="color: hsla(var(--hsl-source-otodom));">otodom.pl</span>
	<span style="color: hsla(var(--hsl-source-nieruchomosci-online));">nieruchomosci-online.pl</span>
	<span style="color: hsla(var(--hsl-source-adresowo));">adresowo.pl</span>
	<span style="color: hsla(var(--hsl-source-morizon));">morizon.pl</span>
	<span style="color: hsla(var(--hsl-source-gratka));">gratka.pl</span>
	<span style="color: hsla(var(--hsl-source-domiporta));">domiporta.pl</span>
	<span style="color: hsla(var(--hsl-source-szybko));">szybko.pl</span>
	<span style="color: hsla(var(--hsl-source-gethome));">gethome.pl</span>
	<!-- <span style="color: hsla(var(--hsl-source-tabelaofert));">tabelaofert.pl</span> -->
	<!-- <span style="color: hsla(var(--hsl-source-krn));">krn.pl</span> -->
</div>

<style>.source-badges{display:flex;flex-wrap:wrap;gap:.75rem;justify-content:center;max-width:36rem}span{border-radius:1rem;box-shadow:var(--shadow-sm);font:var(--f-ui-xs-semibold);padding:.25rem .5rem}</style>
